export default __webpack_public_path__ + "static/media/ic_fuse_96.d9aa04cb.svg";